import { Box, ColumnLayout, ExpandableSection, SpaceBetween } from '@cloudscape-design/components';
import { FC } from 'react';
import { useLocalStorage } from 'react-use';
import { useAuthContext } from '../contexts/AuthContext';
import { useModuleTranslation } from '../lang';
import { ExciseInfo } from '../models/Batch';
import { toDate } from '../utils/timestamp';

interface IExciseDutyProps {
  exciseDuty: ExciseInfo;
}

const ExciseDuty: FC<IExciseDutyProps> = ({ exciseDuty }) => {
  const { currency } = useAuthContext();
  const [exciseDutyExpanded, setExciseDutyExpanded] = useLocalStorage<boolean>('exciseDutyExpanded', false);
  const t = useModuleTranslation('ExciseDuty');

  return (
    <div style={{ marginTop: 10 }}>
      <ExpandableSection
        variant="container"
        headerText={t.header}
        expanded={exciseDutyExpanded}
        onChange={({ detail }) => setExciseDutyExpanded(detail.expanded)}
      >
        <ColumnLayout columns={3} variant="text-grid">
          <SpaceBetween size="m" direction="horizontal">
            <Box variant="awsui-key-label">{t.amountPaid}</Box>
            <Box>{currency(exciseDuty ? (exciseDuty?.exciseDutyAmount ?? 0).toFixed(2) : '0.00')}</Box>
          </SpaceBetween>
          <SpaceBetween size="m" direction="horizontal">
            <Box variant="awsui-key-label">{t.datePaid}</Box>
            <Box>
              {exciseDuty?.exciseDutyPaid ? toDate(exciseDuty?.exciseDutyPaid)?.toLocaleDateString() : t.notPaid}
            </Box>
          </SpaceBetween>
          <SpaceBetween size="m" direction="horizontal">
            <Box variant="awsui-key-label">{t.paymentReferenceId}</Box>
            <Box>{exciseDuty?.exciseDutyPaymentReferenceId ?? t.na}</Box>
          </SpaceBetween>
        </ColumnLayout>
      </ExpandableSection>
    </div>
  );
};

export default ExciseDuty;
